<template>
  <div class="main-custom">
    <Header />
    <section class="container">
      <b-loading isFullPage :active="isLoading" />
      <div class="content">
        <img
          :src="
            isContrast
              ? require('@/assets/svg/email-contrast.svg')
              : require('@/assets/svg/email.svg')
          "
          alt=""
          class="image"
        />
        <div class="title-container">
          <h1 class="is-size-3 has-text-color-7 has-text-weight-bold">
            {{ App.CancelInscription.TITLE }}
          </h1>
          <span class="is-size-4 has-text-color-7">
            {{ getSubtitle }}
          </span>
        </div>
        <div class="description-container">
          <span class="is-size-4 has-text-color-7">
            {{ App.CancelInscription.DESCRIPTION_1 }}
          </span>
          <span class="is-size-4 has-text-color-7">
            {{ App.CancelInscription.DESCRIPTION_2 }}
          </span>
        </div>
        <b-button
          :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
          class="button-width"
          tag="router-link"
          to="/app"
        >
          <span class="has-custom-text-size">
            {{ General.ACCESS_SUITE.toUpperCase() }}
          </span>
        </b-button>
      </div>
    </section>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";

import { mapActions, mapGetters } from "vuex";
import { General, App } from "@/utils/constants";

export default {
  name: "CancelInscription",
  components: {
    Header,
    Footer
  },

  props: {
    notificationName: {
      type: String,
      default: ""
    },

    hash: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      General,
      App,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),

    getSubtitle() {
      return App.CancelInscription.SUBTITLE.replace(
        "(NOTIFICATION_NAME)",
        this.notificationName
      );
    }
  },

  beforeMount() {
    this.isLoading = true;
    if (!(this.notificationName && this.hash)) this.$router.replace("/");
    else this.disableNotificationRequest(this.hash);
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      disableNotificationRequest: "disableNotificationRequest"
    })
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 70%;
  padding: 15px 0;
  min-height: 400px;
}

.image {
  width: 10vw;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 0;
}

.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  gap: 20px;
  padding: 30px;
  border-bottom: 2px solid $color-5;
}

.description-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  gap: 20px;
  padding: 30px;
}

.button-width {
  width: 10vw;
  max-width: 200px;
}

.has-custom-text-size {
  font-size: 0.75rem;
  font-weight: 600;
}
</style>
